<template>
  <div class="container" >
    <img class="logo" src="/static/img/KovoHome_text_white.svg" alt="Logo" />
    <div>
      <div class="loginContainer cardBackground">
        <h1>Set up auto-renewal</h1>

        <h4 class="message">
          Thank you for purchasing the <strong>2-Year Kovo Home Plan</strong> – your home is now on track for secure, intelligent protection.
        </h4>

        <h4 class="message">
          Your plan includes full access to Kovo Home's advanced network protection and leasing of the Guardian Kovo Home device for the next <strong>24 months</strong>.
        </h4>

        <h2 class="subtitle">🔄 What’s Next?</h2>

        <h4 class="message">
          To ensure uninterrupted service <strong>after your 2-year term ends</strong>, please add a payment method now. This will allow your subscription to <strong>automatically renew</strong> when the time comes – no interruptions, no surprises.
        </h4>

        <h4 class="note">
          <em>You won’t be charged again until your current plan expires.</em>
        </h4>


        <div v-if="selectedPaymentMethod === 'card'" class="emailContainer">

          <div class="passwordContainer">

            <h3>
              {{ currentPlan?.descriptions[1]}}
            </h3>
            <hr/>

          </div>

          <h3>Card Information</h3>

          <div id="card-number-element" class="loginInput stripe-input"></div>
          <div class="stripe-inline-row">
            <div id="card-expiry-element" class="loginInput stripe-input half-width"></div>
            <div id="card-cvc-element" class="loginInput stripe-input half-width"></div>
          </div>

          <div class="emailContainer terms-link">
            <h4> By registering you agree to these <a href="#" @click="dialogVisible = true"> terms and conditions </a></h4>
          </div>
          <div>
            <h3>SANDBOX MODE> NOT LIVE</h3>
            <el-button
                class="specialButton"
                type="primary"
                :loading="isLoading"
                :disabled="isLoading"
                @click="addrenewal()"
            >
              Set Up Auto Renew
            </el-button>
          </div>

        </div>

      </div>
    </div>
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />

    <el-dialog
        title="Terms and Conditions"
        :visible.sync="dialogVisible"
        width="90%"
        @close="onClose"
    >
      <terms-and-conditions></terms-and-conditions>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onConfirm">
          Agree
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
/* global Stripe */
import CommonAPIService from "@/servicehandlers/CommonHandler";
import MessageModal from "@/components/MessageModal.vue";
import TermsAndConditions from "@/components/TermsAndConditions.vue";

const commonService = new CommonAPIService()
export default {
  name: 'RegisterPage',
  components: {
    MessageModal,
    TermsAndConditions,
  },
  data(){
    return {
      isLoading: false,
      sessionId: 0,
      dialogVisible: false,
      selectedPaymentMethod: 'card',
      appMessage: {
        text: '',
        type: 'error',
      },
      error: {
        text: '',
        title: '',
      },
      subscriptionPlans: [],
      selectedPlan: 'aivghp2yearplan',
    }
  },
  computed: {
    currentPlan() {
      return this.subscriptionPlans.find(p => p.name === this.selectedPlan );
    }
  },
  watch: {
  },
  mounted() {
    //console.clear()
    //if (this.store.loggedIn){
      //this.goToHome()
    //}
    if (!window.Stripe) {
      const script = document.createElement('script')
      script.src = 'https://js.stripe.com/v3/'
      script.onload = this.initStripe
      document.head.appendChild(script)
    } else {
      this.initStripe()
    }

    this.sessionId = this.$route.query.session_id;

    this.getSubscriptionOptions();

  },
  methods: {

    getSubscriptionOptions(){
      const url = `${process.env.VUE_APP_API_URL}/api/payments/phased_subscriptions`;
      fetch(url)
          .then(res => res.json())
          .then(data => {
            this.subscriptionPlans = data;
            //console.log(JSON.stringify(data, null, 2));
          });
    },

    onConfirm() {
      // your confirm logic here…
      this.dialogVisible = false
    },

    onClose() {
      // optional cleanup when dialog closes
      console.log('Dialog closed')
    },

    async initStripe() {
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
      this.elements = this.stripe.elements()

      const style = {
        base: {
          fontSize: '30px',

          color: '#FFF',
          '::placeholder': {
            color: '#555'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }

      this.cardNumber = this.elements.create('cardNumber', { style })
      this.cardExpiry = this.elements.create('cardExpiry', { style })
      this.cardCvc = this.elements.create('cardCvc', { style })

      this.cardNumber.mount('#card-number-element')
      this.cardExpiry.mount('#card-expiry-element')
      this.cardCvc.mount('#card-cvc-element')
    },

    async setError(field, message){

      this.appMessage.text = message;
      this.appMessage.type = 'error'
      this.$refs.messageModal.open(8000)

    },

    async addrenewal( ) {
      //this.resetErrors()

      this.isLoading = true
      this.isSignUpDisabled = true


      const {paymentMethod, error} = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.cardNumber,
        billing_details: {
          name: `${this.firstname} ${this.lastname}`,
          email: this.email
        }
      })

      if (error) {
        this.errorSignupMessages = error.message;
        this.errorSignup = true;
        this.isLoading = false;
        this.isSignUpDisabled = false;
        return;
      }

      const parameters = {
        planName: this.selectedPlan,
        paymentMethodId: paymentMethod.id || undefined,
        sessionId: this.sessionId
      };

      try {

        commonService
            .klarnaAddRenewal(parameters)
            .then((response) => {
              console.log('Renewal response:', response)
              if (response && response.success) {
                this.isLoading = false
                this.isSignUpDisabled = false

                console.log(JSON.stringify(response, null, 2));

                this.goToFinishRegistration(response.data);

              } else {

                console.log('ERRORRO', JSON.stringify(response, null, 2));
                const message = response && response.errorBody && response.errorBody.details
                    ? `${response.errorBody.error}: ${response.errorBody.details}`
                    : response.errorBody?.error || 'Unexpected registration error';

                this.appMessage.text = message;
                this.appMessage.type = 'error'
                this.$refs.messageModal.open(8000)
              }
            })
            .catch((e) => {
              console.log('Unexpected catch:', JSON.stringify(e, null, 2))

              // Pull the JSON error body out of error.response.data
              const data = e.response && e.response.data;
              const message = data && data.error && data.details
                  ? `${data.error}: ${data.details}`
                  : 'Unexpected registration error';

              this.appMessage.text = message;
              this.appMessage.type = 'error'
              this.$refs.messageModal.open(8000)
            });


      }

      catch (err) {
        this.errorSignupMessages = err.message || 'Subscription failed';
        this.errorSignup = true;
        this.isLoading = false;
        this.isSignUpDisabled = false;
        return;
      }

    },

    async goToHome(){
      this.$router.push({
        name: 'dashboard'
      })
    },
    async goToLogin(){
      this.$router.push({
        name: 'login'
      })
    },
    async goToFinishRegistration( response ){
      this.$router.push({
        name: 'finishregistration',
        params: { regInfo: response }
      })
    },

  },
}
</script>

<style >

/* Make el-select dropdown and inputs dark */
.customSelectx .el-input__inner {
  background-color: #1e1e1e !important; /* or match your dark bg */
  color: var(--text-primary) !important;
  border: 1px solid #444; /* Optional: to match other dark elements */
}

/* Dropdown popup */
.customSelectDropdown {
  background-color: #2a2a2a !important; /* dark background */
  color: #f0f0f0 !important;
}

/* Individual dropdown items */
.customSelectDropdown .el-select-dropdown__item {
  background-color: transparent !important;
  color: #ddd !important;
}

/* Hovered item */
.customSelectDropdown .el-select-dropdown__item:hover {
  background-color: #444 !important;
  color: #fff !important;
}

/* Selected item */
.customSelectDropdown .el-select-dropdown__item.selected {
  background-color: #333 !important;
  font-weight: bold;
  color: #00bcd4 !important;
}

.message {
  text-align: left;
}

.note {
  text-align: left;
}

.colorSwap{
  color: var(--text-primary) !important;
  background-color: transparent !important;
}
.rightCaret{
  color: white;
  width: 12px;
  height: 21px;
}
.otherWrapper{
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
}
.logo{
  width: 80%;
  max-height:120px;
  margin: 0 auto;
  padding: 20px;
}
.loginContainer{
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  margin: 30px;
  border-radius: 12px;
  padding: 20px;
}
.emailContainer{
  width: 100%;
}
.emailContainer, .passwordContainer{
  width: 100%;
  position: relative;
}
.viewPasswordIcon{
  position: absolute;
  right: 0;
  top: calc(50% - 10p);
  width: 50px;
  height: 50px;
  color: var(--text-secondary);
  background-color: var(--text-primary);
  padding: 7.5px;
  border-radius: 12px;
}
input{
  font-size: 20px;
  height: 50px;
}
h3{
  text-align: left;
}
.customSelect .el-input__inner {
  background-color: inherit; /* your dark input bg */
  color: var(--text-primary);
  font-family: inherit;
  font-size: 30px;
  height: 50px;
  border-radius: 10px;
  box-shadow: none;
  transition: border-color 0.2s ease;
  border: none;
  margin:0;
  padding:0;
}

.customSelect .el-input__inner:focus {
  border:none;
  outline: none;
}

.customSelectDropdown .el-select-dropdown__item {
  color: #f0f0f0;
}

.customSelectDropdown .el-select-dropdown__item:hover {
  background-color: inherit;
}

.customSelectDropdown .el-select-dropdown__item.selected {
  font-weight: bold;
  color: #00bcd4;
}

.stripe-input {
  margin-bottom: 12px;
  padding: 10px;
  border: 1px solid #ccd0d5;
  border-radius: 4px;
}

.stripe-inline-row {
  display: flex;
  gap: 12px;
}

.half-width {
  flex: 1;
}

.errorText {
  color: #fa755a;
  font-size: 14px;
  margin-top: 5px;
}

.invalidInput {
  border-color: #fa755a;
}

.terms-link a {
  color:orange;
  text-decoration: none;
}
.terms-link a:hover {
  color: #ff6600;
  text-decoration: none;

}



</style>
